// extracted by mini-css-extract-plugin
module.exports = {"plot":"Charts_plot__qOPY0"};